export default __webpack_public_path__ + "static/media/living-room.46c914e1.webp";